import React, { useEffect } from 'react'
import { getFeatureMaintenanceStatus } from '../api/requests/AppShutdown'

export const FEATURES_LIST = {
  CARDS: 'CARDS', // OpenSparks
  INDOOR_MAPS: 'INDOOR_MAPS', // MappedIn
  VOUCHERS: 'VOUCHERS', // GiftAway
  EMAIL_OTP: 'REGISTER_EMAIL_OTP', // Email OTP for Registration
  TPA_FB: 'REROUTE_FACEBOOK', // Facebook TPA
  PARKING_VOUCHERS: 'PARKING_VOUCHER', // Parking
}

const FEATURE_TYPE = {
  MAINTENANCE: 'feature_maintenance',
  TOGGLE: 'feature_toggle',
}

let features = []
const useFeatureMaintenance = ({ feature }) => {
  const [error, setError] = React.useState(null)
  // Start true so we don't treat "not loaded yet" as "feature unavailable"
  const [loading, setLoading] = React.useState(true)
  const [featureStatuses, setFeatureStatuses] = React.useState(features)

  const fetchFeatureStatus = async () => {
    setLoading(true)
    setError(null)
    try {
      const { data } = await getFeatureMaintenanceStatus()
      const formattedData = await formatData(data)
      features = formattedData
      setFeatureStatuses(formattedData)
      setLoading(false)
      return formattedData
    } catch (error) {
      setError('error')
      setLoading(false)
    }
  }

  const getFeatureStatus = async () => {
    if (Object.keys(features).length > 0) return features

    const responseData = await fetchFeatureStatus()
    return responseData
  }

  // Fetch on mount so we have status before user acts (avoids showing modal while "loading")
  useEffect(() => {
    fetchFeatureStatus()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const formatData = async data => {
    return data.reduce(
      (acc, curr) => ({
        ...acc,
        [curr.feature]:
          curr.type === FEATURE_TYPE.TOGGLE ? curr.available : !curr.available,
      }),
      {},
    )
  }

  const isFeatureAvailable = (checkFeature = feature) => {
    return featureStatuses[checkFeature]
  }

  return {
    error,
    loading,
    featureStatuses,
    getFeatureStatus,
    isFeatureAvailable,
    refreshFeatureStatus: fetchFeatureStatus,
  }
}

export const withFeatureMaintenance = (Component, feature) => {
  return function WrappedComponent(props) {
    const featureMaintenance = useFeatureMaintenance({ feature })
    return <Component {...props} featureMaintenance={featureMaintenance} />
  }
}

export default useFeatureMaintenance
